import { render, staticRenderFns } from "./SystemLog.vue?vue&type=template&id=5bf7772f&scoped=true"
import script from "./SystemLog.vue?vue&type=script&lang=js"
export * from "./SystemLog.vue?vue&type=script&lang=js"
import style0 from "./SystemLog.vue?vue&type=style&index=0&id=5bf7772f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf7772f",
  null
  
)

export default component.exports